import type { FormGroup } from '@angular/forms';
import { ADDRESS_VALIDATION_ERROR_KEYS } from '../validators/address-field.validators';

type NotFoundSectionKey = 'shipFrom' | 'shipTo' | 'returnAddress';

const SECTION_FORM_KEYS: NotFoundSectionKey[] = ['shipFrom', 'shipTo', 'returnAddress'];

/**
 * Clears group-level address-not-found errors from all address sections.
 */
export function clearAddressNotFoundErrors(form: FormGroup): void {
  for (const sectionKey of SECTION_FORM_KEYS) {
    const sectionGroup = form.get(sectionKey) as FormGroup | null;
    if (!sectionGroup?.hasError(ADDRESS_VALIDATION_ERROR_KEYS.addressNotFound)) {
      continue;
    }

    const remainingErrors = { ...sectionGroup.errors };
    delete remainingErrors[ADDRESS_VALIDATION_ERROR_KEYS.addressNotFound];
    sectionGroup.setErrors(Object.keys(remainingErrors).length > 0 ? remainingErrors : null);
  }
}

/**
 * Applies group-level address-not-found errors to the specified sections.
 * Used when AVS returns invalid with no actionable suggested address.
 */
export function applyAddressNotFoundErrors(form: FormGroup, sections: NotFoundSectionKey[]): void {
  clearAddressNotFoundErrors(form);

  for (const sectionKey of sections) {
    const sectionGroup = form.get(sectionKey) as FormGroup | null;
    if (!sectionGroup) {
      continue;
    }

    sectionGroup.setErrors({
      ...sectionGroup.errors,
      [ADDRESS_VALIDATION_ERROR_KEYS.addressNotFound]: true,
    });
    sectionGroup.markAllAsTouched();
  }
}
